import { IModalProps } from '@cp/shared/modal';
import { CareerId } from '@common/const/catalog/career';
import { ModalLayout } from '@cp/ds/src/components/modalLayout';
import { CareerGrid, coreCareerApi } from '@cp/entities/career';
import React from 'react';
import { coreCatalogApi } from '@cp/entities/catalog';
import { ClientSelection } from 'src/entities/client';

export interface CareerSelectModalProps extends IModalProps<CareerId> {
  title?: React.ReactNode;
  clientSelection?: ClientSelection;
}

export const CareerSelectModal: React.FC<CareerSelectModalProps> = ({ onCancel, onSuccess, title, clientSelection }) => {
  const { data: careerDictionary, isLoading } = coreCareerApi.endpoints.getCareers.useQuery();
  const { data: catalogStats } = coreCatalogApi.endpoints.getItemsCityStats.useQuery({ cityId: clientSelection?.cityId });
  return (
    <ModalLayout onClose={onCancel} title={title}>
      <CareerGrid
        careerDictionary={careerDictionary}
        catalogType={clientSelection?.catalogType}
        loading={isLoading}
        onCareerSelect={onSuccess}
        stats={catalogStats}
      />
    </ModalLayout>
  );
};
